export const Roles = {
    Public: 'Public',
	DFO: 'DFO',
    DEO:'DEO'
}

export const roleArray = [Roles.Public, Roles.DFO,Roles.DEO]; // Array of roles
